/* eslint-disable no-unused-vars */
import { View, StyleSheet } from '@react-pdf/renderer';
import React from 'react';
import BudgetDataClient from './BudgetDataClient';
import BudgetRecord from './BudgetRecord';
import BudgetGuarantee from './BudgetGuarantee';
import BudgetConditions from './BudgetConditions';
import BudgetDataTransfer from './BudgetDataTransfer';
import BudgetFinish from './BudgetFinish';

const styles = StyleSheet.create({
  item: {
    marginBottom: '10px',
    padding: '0px 20px',
  },
});

function BudgetBody(props) {
  const { budget, items, images, config, staticData } = props;
  return (
    <View>
      <View style={styles.item}>
        <BudgetDataClient budget={budget} />
      </View>
      <View style={styles.item}>
        <BudgetRecord
          items={items}
          description={budget.description}
          images={images}
          discount={budget.discount}
        />
      </View>
      <View style={styles.item}>
        <BudgetGuarantee guarantee={budget.guarantee} />
      </View>
      <View style={styles.item}>
        <BudgetConditions
          conditions={budget.conditions}
          finishTime={budget.finishTime}
          include={budget.include}
        />
      </View>
      <View style={styles.item}>
        <BudgetDataTransfer staticData={staticData} />
      </View>
      <View style={styles.item}>
        <BudgetFinish config={config} staticData={staticData} />
      </View>
    </View>
  );
}







export default BudgetBody;
